import {MatrixClient, Room} from 'matrix-js-sdk';

export const getCurrentRoom = async (
  client: MatrixClient,
  roomId: string,
  retryDelay = 1000,
  maxRetries = 6
): Promise<Room | undefined> => {
  if (!client) {
    throw new Error('Matrix client is not initialized.');
  }

  let currentRoom: Room | null = null;
  let retries = 0;

  while (!currentRoom && retries < maxRetries) {
    try {
      currentRoom = await client.getRoom(roomId);

      if (currentRoom) {
        return currentRoom;
      } else {
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
        retries++;
      }
    } catch (error) {
      console.error('Error while getting matrix room:', error);
      throw error;
    }
  }
};
